import { isNullOrUndefined } from 'util';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Directive, AfterViewInit, Inject, PLATFORM_ID, ElementRef, Input, Renderer2, OnInit } from '@angular/core';
import { addNoScriptImage, LaziesDirective } from './lazies.directive';

/**
 * 優先使用瀏覽器層級的 loading lazy 屬性，不支援的瀏覽器就使用 lazysizes[https://github.com/aFarkas/lazysizes] 套件
 */
@Directive({
  selector: '[lazyLoading]'
})
export class LazyImageDirective implements AfterViewInit, OnInit {
  /** 可以開始使用元件了 */
  canInit = false;
  /** 是否渲染端為瀏覽器 */
  protected isBrowser: boolean;
  private _isLazy = true;
  @Input('lazyLoading') set isLazy(isLazy: boolean) {
    if (typeof isLazy === 'boolean') {
      this._isLazy = isLazy;
    } else {
      this._isLazy = true;
    }
  }
  get isLazy() { return this._isLazy; }

  constructor(
    @Inject(PLATFORM_ID) protected platformId: any,
    protected el: ElementRef,
    protected renderer: Renderer2,
    ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      if (LaziesDirective.useOnlyLazies) {
        if (!LaziesDirective.isPluginInit) {
          LaziesDirective.loadPlugin(renderer);
        }
      }
    }
  }

  ngOnInit() {
    if (this.isLazy) {
      const imgEl = this.el.nativeElement as HTMLImageElement;
      this.renderer.setAttribute(imgEl, 'loading', 'lazy');
      if (!this.isBrowser) { addNoScriptImage(this.renderer, imgEl); }
    }
  }

  ngAfterViewInit() {
    const imgEl = this.el.nativeElement as HTMLImageElement;
    if (this.isBrowser) {
      const lostSizeSpec = !(imgEl.getAttribute('width') && imgEl.getAttribute('height')) && !(imgEl.style.width && imgEl.style.height);

      if (!LaziesDirective.useOnlyLazies) {
        this.initBroswerLevelLazyLoadDom(imgEl, lostSizeSpec);
        this.canInit = true;
      } else {
        if (!LaziesDirective.isPluginInit) {
          LaziesDirective.pulginInit.subscribe(() => {
            this.initLaziesDom(imgEl, lostSizeSpec);
            this.canInit = true;
          });
        } else {
          setTimeout(() => {
            this.initLaziesDom(imgEl, lostSizeSpec);
            this.canInit = true;
          }, 0);
        }
      }
    }
  }

  initBroswerLevelLazyLoadDom(el: HTMLImageElement, lostSizeSpec: boolean) {
    if (!this.isLazy) { return; }
    if (el.dataset.src) {
      el.src = el.dataset.src;
    }
    if (lostSizeSpec) {
      const onLoadHandler = (e) => {
        const cs = getComputedStyle(el, null);
        if (parseFloat(cs['minHeight'])) {
          el.style.minHeight = 'unset';
        }
        el.removeEventListener('load', onLoadHandler);
      };
      el.addEventListener('load', onLoadHandler);
    }
  }

  initLaziesDom(el: HTMLImageElement, lostSizeSpec: boolean) {
    if (!this.isLazy) { return; }
    if (!el.classList.contains('lazyload')) {
      el.classList.add('lazyload');
      if (!el.dataset.src) {
        el.dataset.src = el.src;
        el.src = '';
      }
      if (lostSizeSpec) {
        const onLoadHandler = (e) => {
          const cs = getComputedStyle(el, null);
          if (parseFloat(cs['minHeight'])) {
            el.style.minHeight = 'unset';
          }
          el.removeEventListener('load', onLoadHandler);
        };
        el.addEventListener('load', onLoadHandler);
      }
    }
  }
}
